// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/InfoBanner/InfoBanner.sass
// module id = 419
// module chunks = 0